import { render, staticRenderFns } from "./SafetyInspectionPage.vue?vue&type=template&id=42cd7ea8"
import script from "./SafetyInspectionPage.vue?vue&type=script&lang=js"
export * from "./SafetyInspectionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports